import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.admin, routes: [{ path: '/dropoff-stats', component: FuseLoadable({ loader: () => import('./DropoffStatsApp') }) }] };

export default [Index];
